var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pi-card-box",class:{
    'pi-card-flex': _vm.flex,
    'pi-card-border': _vm.type == 'border',
    small: _vm.size == 'small',
  }},[(_vm.headerShow)?_c('div',{staticClass:"pi-card-header"},[(_vm.$slots['title'])?[_vm._t("title")]:_c('pi-card-box-title',{attrs:{"isCard":true,"title":_vm.title,"size":_vm.titleSize,"titleIcon":_vm.titleIcon}}),(_vm.$slots['header-content'] || _vm.$slots['header-right'])?_c('div',{staticClass:"pi-card-header-flex"},[_vm._t("header-content")],2):_vm._e(),(_vm.$slots['header-right'])?_c('div',{staticClass:"pi-card-header-right"},[_vm._t("header-right")],2):_vm._e()],2):_vm._e(),_c('div',{staticClass:"pi-card-content",class:{
      'pi-card-content-flex': _vm.flex,
      'no-header': !_vm.headerShow,
      'title-small': _vm.titleSize == 'small',
    }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }